// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2BPzK","title":"Images90_title__n1yAf","images":"Images90_images__1gFpy"};